export enum OAuth2DiscordPrompt {
    None = 'none',
    Consent = 'consent',
}
